module.exports = __webpack_public_path__ + "static/media/phone_sel.1cbfc78d.svg";